import {getClosestMaxAllocation} from "../utilities/unitsHelper";
import store from "@continente/vue/components/store";

/**
 * Updates quantity data set for product
 * @param {string} selector - the element to be initialized selector
 * @param {string} pid - product id
 * @param {number} invQty - max product allocation
 */
const updateMaxNumberOfUnitsPerSale = (selector, pid, invQty) => {
    const vues = document.querySelectorAll(selector);

    Array.from(vues).forEach(el => {
        let measurementInfo = (el.dataset.measureOptions) ? JSON.parse(el.dataset.measureOptions) : null;

        if (measurementInfo) {
            //set inventory allocation as max quantity if it is greater than max configured for product
            //the smallest between inventory and maxNumberOfUnitsPerSale will be in use as MAX
            if (invQty > measurementInfo.maxNumberOfUnitsPerSale) {
                invQty = measurementInfo.maxNumberOfUnitsPerSale;
            }

            invQty = getClosestMaxAllocation(invQty, measurementInfo.stepQuantity);
            measurementInfo.maxNumberOfUnitsPerSale = invQty;
            el.dataset.measureOptions = JSON.stringify(measurementInfo);
            store.commit("setProductMeasure", {pid: pid, measurementInfo: measurementInfo});
        }
    });
};

/**
 * Initialize set of max allocation to sale for the Quantity Component
 *
 * @param {string} pid
 * @param {number} max allocation
 */
const setMaxNumberOfUnitsPerSale = (pid, invQty) => {
    updateMaxNumberOfUnitsPerSale(`.product-qty-vue[data-pid="${pid}"]`, pid, invQty);
};

export {setMaxNumberOfUnitsPerSale};
